import React from "react";
import "./TradeStats.scss";
import { dollarUS } from "../../../../utilities/formatters";

const TradeStats = ({ selectedDateValue }) => {
  // Initialize variables to calculate metrics
  let totalTrades = 0;
  let totalProfitOrLoss = 0;
  let grossProfit = 0;
  let grossLoss = 0;
  let totalVolume = 0;
  let buyCount = 0;
  let sellCount = 0;
  let winningTrades = 0;
  let commission = 0;
  let symbol = null;

  // Loop through the trade data
  console.log(selectedDateValue,"selectedDateValue")
  selectedDateValue?.forEach((trade) => {
    totalTrades += 1;
    totalProfitOrLoss += trade?.profit;
    totalVolume += trade?.volume||Number(trade?.lots/2)||0;
    commission += trade?.commission||Number(trade?.executionFee);
    symbol = trade?.symbol||trade?.instrument;

    if (trade?.profit > 0) {
      grossProfit += trade?.profit;
      winningTrades += 1;
    } else if (trade?.profit < 0) {
      grossLoss += trade?.profit;
    }

    // Count the trade types (Buy or Sell)
    if (trade?.action === "Buy" || trade?.trade_side === "Buy"||trade?.side === "Buy") {
      buyCount += 1;
    } else if (trade?.action === "Sell" || trade?.trade_side === "Sell"||trade?.side === "Sell") {
      sellCount += 1;
    }
  });

  // Calculate the win rate percentage
  const winRate =
    totalTrades > 0 ? ((winningTrades / totalTrades) * 100).toFixed(2) : 0;

  console.log(winRate, winningTrades, totalTrades, selectedDateValue);
  // Prepare the statistics data for display
  const statisticsData = [
    {
      total_trades: totalTrades.toLocaleString(),
      "gross_p&l": dollarUS(totalProfitOrLoss || 0),
      winners: dollarUS(grossProfit || 0),
      losers: dollarUS(Math.abs(grossLoss) || 0),
      winrate: `${winRate}%`,
      trade_type: `Buy: ${buyCount}, Sell: ${sellCount}`,
      volume: totalVolume?.toFixed(2),
      profit_factor: "--",
      commissions: commission,
      // symbol: symbol ? symbol : "--",
    },
  ];

  return (
    <div className="TradeStatsContainer">
      <div className="TradeStatsWrapper">
        {statisticsData?.map((item, index) => {
          return (
            <div key={index} className="dataBox">
              {Object.entries(item).map(([key, value]) => {
                return (
                  <div key={key} className="dataRow">
                    <span className="dataKey">{key.replace(/_/g, " ")}</span>
                    <span className="dataValue">{value}</span>
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TradeStats;
